import { motion } from 'framer-motion'

const SvgComponent = ({transition, ...props}) => (
  <motion.svg

    initial={{
      y: '30%',
      x: '-5%',
      scale: 0.6,
      opacity: 0
    }}
    animate={{
      y: '0%',
      opacity: 1,
      transition: { ...transition }
    }}
    exit={{
      y: '30%',
      opacity: 0,
      transition: { ...transition }
    }}

    viewBox="0 0 237 222"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#rsbq38ijaa)">
      <path
        d="M169.903 161.082c.114-.132 5.943-7.967 13.485-13.82-.887-.462-2.062-.821-3.559-.821-1.67 0-3.54.444-5.546 1.326-3.78 1.657-6.546 4.923-10.048 9.063-1.988 2.345-4.239 5.008-7.005 7.726-3.682 3.625-9.133 6.901-16.213 9.742a98.973 98.973 0 0 1-7.156 2.554l.142.014c2.355.274 4.725.519 7.056.736.114.01.227.024.34.033 3.266-1.076 5.834-2.058 7.609-2.907 5.159-2.478 13.872-8.345 20.891-13.65l.004.004z"
        fill="url(#zijxn4elob)"
      />
      <path
        d="M192.393 157.485c5.093-4.196 10.705-8.807 16.515-11.252-3.417-2.214-7.136-2.464-11.856-.916-4.484 1.473-7.212 3.668-19.371 13.806-7.34 6.122-20.339 15.25-27.249 18.569-.377.184-.788.368-1.227.557.425.028.845.051 1.256.075.335.019.679.043 1 .057.888.047 1.747.089 2.554.118.897.033 1.812.033 2.742.014.302-.005.618-.033.925-.043a54.735 54.735 0 0 0 1.935-.094c.373-.028.765-.076 1.143-.113.609-.057 1.213-.109 1.836-.184.41-.052.84-.123 1.26-.18.557-.08 1.114-.155 1.68-.245 6.155-3.875 18.989-13.853 23.482-17.431a280.958 280.958 0 0 0 3.366-2.742l.009.004z"
        fill="url(#ob4gwsgpoc)"
      />
      <path
        d="M194.48 160.02a287.581 287.581 0 0 1-3.408 2.775c-.123.099-9.256 7.349-16.992 12.966.288-.08.576-.156.859-.236.179-.052.364-.099.543-.151a115.297 115.297 0 0 0 4.498-1.388c.59-.193 1.18-.391 1.756-.59.118-.042.236-.08.349-.122.614-.213 1.223-.43 1.817-.647a149.904 149.904 0 0 0 3.904-1.477c.038-.015.075-.033.113-.048.557-.217 1.1-.439 1.624-.651l.141-.057a206.831 206.831 0 0 0 4.461-1.883c.056-.023.118-.052.174-.075.373-.166.732-.321 1.072-.472.042-.019.09-.043.137-.062.363-.16.708-.311 1.024-.453 3.04-1.35 6.419-3.913 10.323-6.886 4.479-3.403 9.482-7.203 15.212-10.059-1.623-1.722-4.04-2.6-7.24-2.6-6.755.906-13.986 6.858-20.367 12.111v.005z"
        fill="url(#tho9zbg3bd)"
      />
      <path
        d="M228.284 151.888c-.868 0-1.718.175-2.52.524-6.367 2.766-11.965 7.018-16.902 10.771-4.069 3.091-7.585 5.768-10.979 7.273-5.475 2.431-18.304 8.128-31.473 10.389-3.823.647-7.429.972-10.724.972-.599 0-1.194-.009-1.789-.033-3.53-.132-7.835-.42-12.456-.84a316.578 316.578 0 0 1-16.01-1.874c-21.183-3.044-23.204-5.819-23.869-6.735-.963-1.322-.675-2.374-.415-2.884.797-1.567 2.978-1.775 5.007-1.775 4.669 0 11.819 1.421 12.121 1.482l.18.048c.061.018 6.046 1.906 12.376 1.906 3.271 0 6.046-.495 8.25-1.477a12.087 12.087 0 0 0 1.586-.854c1.931-1.242 4.13-3.177 3.634-5.357-.363-1.596-2.02-2.747-2.652-2.823-1.09-.137-4.626-.949-10.781-2.374-6.792-1.572-15.245-3.531-20.659-4.546-1.756-.33-3.634-.736-5.617-1.17-6.292-1.374-13.424-2.926-21.155-2.926-3.601 0-6.943.33-10.223 1.014l-2.068.425c-13.83 2.842-26.894 5.527-37.085 22.996-1.5 2.572-2.652 5.282-3.875 8.151-2.001 4.702-4.069 9.558-7.797 13.872-2.181 2.526-5.735 5.646-9.502 8.945C8.05 209.231.804 215.584.417 218.062c1.204 1.209 8.902 5.093 22.925 3.3 36.424-4.654 44.07-15.052 74.623-15.029 2.979 0 6.108.151 9.308.151 23.666 0 81.845-3.021 110.873-31.001 5.192-5.003 15.09-15.963 18.271-19.503-1.548-1.491-4.739-4.092-8.142-4.092h.009z"
        fill="url(#y5ujm720le)"
      />
    </g>
    <path
      d="M166.505 41.588c0 1.652 1.416 2.549 3.493 3.21v-6.703c-2.502.567-3.493 1.936-3.493 3.493z"
      fill="url(#o43i88quhf)"
    />
    <path
      d="M174.722 52.916v6.513c2.36-.519 3.398-1.746 3.398-3.257 0-1.652-1.369-2.548-3.398-3.256z"
      fill="url(#o055qdojgg)"
    />
    <path
      d="M171.98 12.442c-19.914 0-36.118 16.203-36.118 36.117 0 19.914 16.204 36.118 36.118 36.118 19.913 0 36.117-16.204 36.117-36.118s-16.204-36.117-36.117-36.117zm2.737 53.218v5.286h-4.72v-5.145c-4.672-.283-9.156-1.746-11.752-3.776l2.596-5.758c2.36 1.746 5.758 3.02 9.156 3.351v-7.882c-5.239-1.275-11.092-3.021-11.092-9.77 0-5.004 3.635-9.3 11.092-10.149v-5.239h4.72v5.145c3.54.283 6.986 1.227 9.582 2.879l-2.36 5.806c-2.407-1.37-4.862-2.172-7.222-2.455v8.024c5.24 1.227 10.998 2.974 10.998 9.629 0 4.909-3.587 9.157-10.998 10.054z"
      fill="url(#dbqh47tuyh)"
    />
    <path
      d="M171.857 0c-26.819 0-48.564 21.74-48.564 48.564s21.74 48.56 48.564 48.56 48.559-21.74 48.559-48.56C220.416 21.745 198.676 0 171.857 0zm0 91.592c-23.727 0-43.032-19.305-43.032-43.033 0-23.727 19.305-43.027 43.032-43.027 23.727 0 43.032 19.305 43.032 43.032 0 23.727-19.305 43.032-43.032 43.032v-.004z"
      fill="url(#7dt3ousxqi)"
    />
    <path
      d="M94.93 87.748c0 .93.796 1.433 1.964 1.805v-3.769c-1.407.319-1.964 1.088-1.964 1.964z"
      fill="url(#v172zbisdj)"
    />
    <path
      d="M99.55 94.118v3.663c1.327-.292 1.911-.982 1.911-1.831 0-.93-.77-1.434-1.911-1.832z"
      fill="url(#epjly8mppk)"
    />
    <path
      d="M98.008 71.36c-11.198 0-20.309 9.111-20.309 20.308 0 11.198 9.111 20.309 20.309 20.309 11.197 0 20.308-9.111 20.308-20.309 0-11.197-9.111-20.308-20.308-20.308zm1.54 29.924v2.972h-2.655v-2.893c-2.627-.159-5.149-.982-6.609-2.123l1.46-3.238c1.327.982 3.238 1.699 5.149 1.885v-4.433c-2.946-.716-6.237-1.698-6.237-5.493 0-2.814 2.044-5.229 6.237-5.706v-2.946h2.654V82.2c1.991.16 3.928.69 5.388 1.62l-1.327 3.264c-1.354-.77-2.734-1.221-4.06-1.38v4.512c2.945.69 6.183 1.672 6.183 5.414 0 2.76-2.017 5.149-6.184 5.653z"
      fill="url(#11ms5d82pl)"
    />
    <path
      d="M97.939 64.363c-15.08 0-27.307 12.225-27.307 27.307 0 15.083 12.224 27.305 27.307 27.305 15.083 0 27.304-12.224 27.304-27.305 0-15.08-12.224-27.307-27.304-27.307zm0 51.501c-13.342 0-24.197-10.855-24.197-24.196 0-13.342 10.855-24.194 24.197-24.194 13.342 0 24.197 10.855 24.197 24.196 0 13.342-10.855 24.197-24.197 24.197v-.003z"
      fill="url(#cik1muk49m)"
    />
    <path
      d="M142.814 120.355c0 .597.512.922 1.263 1.161v-2.423c-.904.205-1.263.699-1.263 1.262z"
      fill="url(#ydrm7oyfjn)"
    />
    <path
      d="M145.785 124.451v2.354c.853-.187 1.229-.631 1.229-1.177 0-.597-.495-.921-1.229-1.177z"
      fill="url(#kx8yy2r01o)"
    />
    <path
      d="M144.794 109.819c-7.199 0-13.056 5.857-13.056 13.056 0 7.198 5.857 13.055 13.056 13.055 7.198 0 13.055-5.857 13.055-13.055 0-7.199-5.857-13.056-13.055-13.056zm.989 19.237v1.911h-1.706v-1.86c-1.689-.102-3.31-.631-4.248-1.365l.938-2.081c.853.631 2.082 1.092 3.31 1.211v-2.849c-1.894-.461-4.009-1.092-4.009-3.532 0-1.808 1.313-3.361 4.009-3.668v-1.894h1.706v1.86c1.28.102 2.525.444 3.464 1.041l-.853 2.098c-.87-.495-1.758-.785-2.611-.887v2.9c1.894.444 3.976 1.075 3.976 3.481 0 1.774-1.297 3.31-3.976 3.634z"
      fill="url(#ebufyzyrpp)"
    />
    <path
      d="M144.749 105.323c-9.694 0-17.555 7.858-17.555 17.554 0 9.696 7.859 17.553 17.555 17.553s17.553-7.858 17.553-17.553c0-9.694-7.859-17.554-17.553-17.554zm0 33.107c-8.577 0-15.555-6.978-15.555-15.554 0-8.577 6.978-15.554 15.555-15.554s15.555 6.978 15.555 15.555-6.978 15.555-15.555 15.555v-.002z"
      fill="url(#97cc2jobgq)"
    />
    <defs>
      <linearGradient
        id="zijxn4elob"
        x1={113.891}
        y1={165.937}
        x2={247.905}
        y2={141.153}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="ob4gwsgpoc"
        x1={125.131}
        y1={165.702}
        x2={285.571}
        y2={133.072}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="tho9zbg3bd"
        x1={154.722}
        y1={165.315}
        x2={283.863}
        y2={139.391}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="y5ujm720le"
        x1={-94.744}
        y1={194.736}
        x2={482.148}
        y2={-24.791}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E14FFE" />
        <stop offset={0.063} stopColor="#E14FFE" />
        <stop offset={0.125} stopColor="#E04FFE" />
        <stop offset={0.188} stopColor="#DD4FFE" />
        <stop offset={0.25} stopColor="#D84FFE" />
        <stop offset={0.313} stopColor="#CF4FFE" />
        <stop offset={0.375} stopColor="#C250FE" />
        <stop offset={0.438} stopColor="#AF50FE" />
        <stop offset={0.5} stopColor="#9751FF" />
        <stop offset={0.563} stopColor="#7F51FF" />
        <stop offset={0.625} stopColor="#6C51FF" />
        <stop offset={0.688} stopColor="#5F52FF" />
        <stop offset={0.75} stopColor="#5652FF" />
        <stop offset={0.813} stopColor="#5152FF" />
        <stop offset={0.875} stopColor="#4E52FF" />
        <stop offset={0.938} stopColor="#4D52FF" />
        <stop offset={1} stopColor="#4D52FF" />
      </linearGradient>
      <linearGradient
        id="o43i88quhf"
        x1={168.76}
        y1={38.56}
        x2={166.36}
        y2={43.077}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="o055qdojgg"
        x1={176.916}
        y1={53.367}
        x2={174.585}
        y2={57.759}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="dbqh47tuyh"
        x1={182.497}
        y1={17.448}
        x2={166.449}
        y2={75.427}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="7dt3ousxqi"
        x1={185.996}
        y1={6.731}
        x2={164.418}
        y2={84.687}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="v172zbisdj"
        x1={95.322}
        y1={84.817}
        x2={101.376}
        y2={90.994}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="epjly8mppk"
        x1={99.931}
        y1={93.178}
        x2={105.815}
        y2={99.189}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="11ms5d82pl"
        x1={85.807}
        y1={60.931}
        x2={138.68}
        y2={164.456}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="cik1muk49m"
        x1={81.533}
        y1={50.341}
        x2={152.624}
        y2={189.535}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="ydrm7oyfjn"
        x1={143.066}
        y1={118.471}
        x2={146.959}
        y2={122.442}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="kx8yy2r01o"
        x1={146.03}
        y1={123.846}
        x2={149.813}
        y2={127.71}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="ebufyzyrpp"
        x1={136.95}
        y1={103.115}
        x2={170.94}
        y2={169.667}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <linearGradient
        id="97cc2jobgq"
        x1={134.202}
        y1={96.309}
        x2={179.903}
        y2={185.79}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFB800" />
        <stop offset={0.304} stopColor="#FFCC49" />
        <stop offset={0.612} stopColor="#FFE39A" />
        <stop offset={1} stopColor="#fff" />
      </linearGradient>
      <filter
        id="rsbq38ijaa"
        x={-3.583}
        y={140.33}
        width={244}
        height={85.497}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feGaussianBlur in="BackgroundImage" stdDeviation={2} />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_1740_10270"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_backgroundBlur_1740_10270"
          result="shape"
        />
      </filter>
    </defs>
  </motion.svg>
)

export default SvgComponent
